import NotFoundContainer from "../components/emptyState/notfound";

// ----------------------------------------------------------------------

export default function NotFound404(){
    return (
        <NotFoundContainer />
    )
}